import React from 'react';
import styled from 'styled-components';

import { basename } from '../../setting';
import useHomeStore from '../../store/useHomeStore';
import useViewStore from '../../store/useViewStore';
import LanguageSwitcher from './LanguageSwitcher';
import FormButtonDangerBorder from '../form/FormButtonDangerBorder';
import BXHeader from '../core/BXHeader/pages/Layout/Header';

function NavigationBarHome() {
  const { isSubBarSticky } = useHomeStore((state) => state);
  const { isPadView } = useViewStore((state) => state);
  
  return (
    <Header $isSubBarSticky={isSubBarSticky}>
      <HeaderContent $isSubBarSticky={isSubBarSticky}>
        <Nav>
          <a href={`/${basename}`}>
            <Logo src={`${process.env.PUBLIC_URL}/images/logo_blue-cross_bilingual.png`} alt="Company Logo" />
          </a>

          {
            // !isPadView &&
            // <NavList>
            //   <NavItem>產品</NavItem>
            //   <NavItem>服務</NavItem>
            //   <NavItem>索償</NavItem>
            //   <NavItem>網誌</NavItem>
            // </NavList>
          }
        </Nav>
        <UserSection>
          <LanguageSwitcher />
          {
            // isPadView ?
            //   <MenuBtn>
            //     <MenuImg src={`${process.env.PUBLIC_URL}/images/line-3.png`} alt="Menu" />
            //   </MenuBtn>
            //   :
            //   <>
            //     <LanguageSwitcher />
            //     <FormButtonDangerBorder size={"extraSmall"} >登入</FormButtonDangerBorder>
            //   </>
          }
        </UserSection>
      </HeaderContent>
    </Header>
  );
}

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 5rem;
  flex-shrink: 0;
  background-color: var(--aia-bx-white);
  z-index: 500;
  box-sizing: border-box;

  ${props => props.$isSubBarSticky ? "width: 100%; display: flex; justify-content: center;" : "padding: 1.125rem 1.5rem; width: 80%; max-width: 1200px; border-bottom-left-radius: 1.25rem; border-bottom-right-radius: 0.5rem;"}

  @media (max-width: 991px) {
    width: 100%;
    max-width: none;
    border-radius: 0;
  }
`;

const HeaderContent = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  
  ${props => props.$isSubBarSticky ? "width: 80%; max-width: 1200px; padding: 1.125rem 1.5rem;" : "width: 100%;"}

  @media (max-width: 991px) {
    width: 100%;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 2.5rem;
  margin: 0;
  padding: 0;
`;

const Logo = styled.img`
  width: 207px;
  height: 44px;
`;

const NavList = styled.ul`
  flex-shrink: 0;
  list-style: none;
  display: flex;
  gap: 2.5rem;
  margin: 0;
  padding: 0;
`;

const NavItem = styled.li`
  font-size: 1.125rem;
  color: var(--aia-bx-gray-7);
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  cursor: pointer;
`;

const UserSection = styled.section`
  display: flex;
  gap: 16px;
  text-align: center;
  margin: auto 0;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const MenuBtn = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  
  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

const MenuImg = styled.img`
  width: 32px;
  height: 33px;
`;

export default NavigationBarHome;